import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import {environment} from "../../environments/environment";


@Injectable({ providedIn: 'root' })
export class AuthApiService {

  constructor(
    private http: HttpClient
  ){}

  login(user, pass): Observable<any> {


    const tokenData = {
      username: user,
      password: pass,
      applicacionCode: environment.applicationCode
    }

    const json = JSON.stringify(tokenData);

    const bytes = new TextEncoder().encode(json);

    const binary = Array.from(bytes)
      .map(byte => String.fromCharCode(byte))
      .join('');

    const b64Token = btoa(binary);
    // const b64Token = btoa(JSON.stringify(tokenData))

    const authData = {
      application: environment.application,
      accessProvider: environment.accessProvider,
      platform: 'WEB',
      token: b64Token
    }

    let timestamp = new Date().getTime();
    return this.http.post<any>(environment.securityUrl + '/auth?time='+timestamp, authData)
  }

  changePassword(newPassword, currentPassword): Observable<any> {

    const requestBody = {
      currentPassword: currentPassword,
      password: newPassword
    }

    return this.http.post<any>(environment.apiBaseUrl + `/accounts/change_password`, requestBody);
  }

  refreshToken(refreshToken: string): Observable<any> {
    let timestamp = new Date().getTime();
    return this.http.post<any>(environment.securityUrl + '/auth/renew?time='+timestamp, {}, {
      headers: {
        Authorization: `Bearer ${refreshToken}`
      }
    })
  }
  askPasswordChange(email: string, companyCode: string) {
    return this.http.post<any>(environment.apiBaseUrl + '/accounts/public/resetPassword', {
      username:email,
      scopeCode:companyCode
    })
  }
}

